var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBtnMore = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 12,
  r: 2,
  transform: "rotate(-90 4 12)",
  fill: "#3E4248"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 2,
  transform: "rotate(-90 12 12)",
  fill: "#3E4248"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 12,
  r: 2,
  transform: "rotate(-90 20 12)",
  fill: "#3E4248"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBtnMore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_btn_More.66673e2f5cc632aa9b7d5448bf306efd.svg";